// extracted by mini-css-extract-plugin
export var buttons = "_ax-0";
export var buttonsActive = "_ax-h";
export var cancelConfirm = "_ax-1";
export var closeButton = "_ax-2";
export var column = "_ax-3";
export var container = "_ax-4";
export var detailHeader = "_ax-6";
export var detailTitle = "_ax-7";
export var detailsContent = "_ax-5";
export var header = "_ax-8";
export var headerWithClose = "_ax-9";
export var icon = "_ax-a";
export var infoIcon = "_ax-c";
export var informationContainer = "_ax-b";
export var sideDrawer = "_ax-d";
export var sideDrawerOpen = "_ax-e";
export var stickyFooter = "_ax-f";
export var typeOption = "_ax-g";